import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cus-sitepolicy',
  templateUrl: './sitepolicy.component.html',
  styleUrls: ['./sitepolicy.component.scss']
})
export class SitepolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
